// extracted by css-extract-rspack-plugin
export default {"TargetsPanelText":"TargetsPanel-module__TargetsPanelText__uyh_O","TargetsPanelHeading":"TargetsPanel-module__TargetsPanelHeading__fwqKR"};